export type FraudScoreLevel = 'OK' | 'WARN' | 'ALERT';

export interface FraudScoreInfo {
  level: FraudScoreLevel;
  label: string;
  color: string;
}

const LEVELS: Record<FraudScoreLevel, Omit<FraudScoreInfo, 'level'>> = {
  OK: { label: 'OK — нормальное поведение', color: '#2e7d32' },
  WARN: { label: 'WARN — подозрительная активность', color: '#ed6c02' },
  ALERT: { label: 'ALERT — вероятный фрод', color: '#d32f2f' },
};

/** Parse fraud_score from API (number, numeric string, or null/empty). */
export function parseFraudScore(value: unknown): number | null {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : null;
}

export function fraudScoreLevel(score: number): FraudScoreLevel {
  if (score <= 29) return 'OK';
  if (score <= 70) return 'WARN';
  return 'ALERT';
}

export function fraudScoreInfo(score: number): FraudScoreInfo {
  const level = fraudScoreLevel(score);
  return { level, ...LEVELS[level] };
}

/** DevExtreme cellTemplate: colored score + tooltip with level description. */
export function fraudScoreCellTemplate(
  cellElement: HTMLElement,
  cellInfo: { value?: unknown; data?: { fraud_score?: unknown } },
) {
  const raw = cellInfo.value ?? cellInfo.data?.fraud_score;
  const score = parseFraudScore(raw);
  const span = document.createElement('span');
  if (score == null) {
    span.textContent = '';
    cellElement.appendChild(span);
    return;
  }
  const info = fraudScoreInfo(score);
  span.textContent = String(score);
  span.title = info.label;
  span.style.color = info.color;
  span.style.fontWeight = '600';
  cellElement.appendChild(span);
}
